import { createContext, useContext } from 'react';
import { useImmerReducer } from 'use-immer';

const authInit = {
    user: null,
    selectedAccount: null,
    selectedAccountPermissions: {},
    cubeApi: null,
    isLoading: true,
    allowCubeQueries: true,
};

function authReducer ( draft, { type, payload } ) {
    switch (type) {
        case 'setAuth': {
            let newUser = JSON.parse(JSON.stringify(payload))
            newUser.UserRoles = {}
            for (let i = 0 ; i < payload.UserRoles?.length; i++) {
                const userRole = payload.UserRoles[i]
                const normRole = {[userRole.Role.id]: userRole.Role}
                const normAccount = {[userRole.Account.id]: userRole.Account}
                const newUserRole = {...userRole, "Role": normRole, "Account": normAccount}
                newUser.UserRoles[[newUserRole.id]] = newUserRole
            }
            draft.user = newUser
            break;
        }
        case 'removeAuth': {
            draft.user = undefined;
            break;
        }
        case 'updateAuth': {
            draft.user = {...draft.user, ...payload};
            break;
        }
        case 'setIsLoading': {
            draft.isLoading = payload;
            break;
        }
        case 'setSelectedAccount': {
            draft.selectedAccount = payload;
            break;
        }
        case 'setSelectedAccountPermissions': {
            let currentRole;
            if (draft.selectedAccount && draft.user && draft.user.UserRoles ) {
                const parsedAccount = JSON.parse(JSON.stringify(draft.selectedAccount))
                const parsedUser = JSON.parse(JSON.stringify(draft.user))
                // in this case, it is ok if accounts is not normalized (outside of UserRoles) because we solely will use it to find data O(n)
                const foundAccount = JSON.parse(JSON.stringify(parsedUser.Accounts)).find(account => account.id === parsedAccount.id)
                currentRole = Object.values(parsedUser.UserRoles).find(role => {
                    let currentId = Object.keys(role.Account)[0]
                    return Number(currentId) === Number(foundAccount.id)
                })
                
            } else currentRole = null
            if (currentRole) {
                const permissionsArr = Object.values(currentRole.Role)[0].Permissions 
                if (permissionsArr.length) {
                    permissionsArr.forEach(perm => draft.selectedAccountPermissions[perm.id] = perm) 
                }
            } else {
                draft.selectedAccountPermissions = {}
            }
            break;
        }
        case 'setCubeApi': {
            draft.cubeApi = payload;
            break;
        }
        default: {
            return null;
        }
    }
}

const [AuthContext,AuthDispatchContext] = [createContext(null),createContext(null)];

export default function AuthProvider ({ children, init }) {
    const [authStore, dispatch] = useImmerReducer(authReducer, init || authInit);

    return (
        <AuthContext.Provider value={authStore}>
            <AuthDispatchContext.Provider value={dispatch}>
                {children}
            </AuthDispatchContext.Provider>
        </AuthContext.Provider>
    )
}

export function useAuthStore() {
    return useContext(AuthContext);
}

export function useAuthDispatch() {
    return useContext(AuthDispatchContext);
}
